/**
 * @namespace PIXI.extras
 */
export { default as TextureTransform } from './TextureTransform';
export { default as MovieClip } from './MovieClip';
export { default as TilingSprite } from './TilingSprite';
export { default as TilingSpriteRenderer } from './webgl/TilingSpriteRenderer';
export { default as BitmapText } from './BitmapText';

export { default as cacheAsBitmap } from './cacheAsBitmap';
export { default as getChildByName } from './getChildByName';
export { default as getGlobalPosition } from './getGlobalPosition';
